import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import numeral from 'numeral';
import OffersItemSC from './offers-item.styled';
import { SmallText, BodyText } from '../../typography';
import Mark from '../../ui/mark';
import dlt from '../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';
import Button from '../../ui/button';
import Moment from 'react-moment';
import { ReactComponent as RightArrowIcon } from '../../../assets/img/svg/right-arrow-b.svg';
import { ReactComponent as AvatarIcon } from '../../../assets/img/svg/reaction-avatar.svg';

const OffersItem = ({
  id,
  date,
  amount,
  status,
  name,
  payments,
  paymentsTotal,
  isTablet,
  hasPagination,
  onCancelClick,
  inArrear,
  hasBiddings,
  biddingsCount,
  history,
  sellType,
}) => {
  return (
    <OffersItemSC hasPagination={hasPagination}>
      {isTablet ? (
        <td>
          <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
            <BodyText className="bolder">{name}</BodyText>
            <BodyText className="bolder">{numeral(amount).format('0,00.00')} €</BodyText>
          </Link>
        </td>
      ) : (
        <>
          <td>
            <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
              <BodyText className="bolder">{name}</BodyText>
            </Link>
          </td>
          <td>
            <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
              <BodyText>{numeral(amount).format('0,00.00')} €</BodyText>
            </Link>
          </td>
        </>
      )}

      {isTablet ? null : (
        <td>
          <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
            <BodyText>
              {payments}/{paymentsTotal}
            </BodyText>
          </Link>
        </td>
      )}

      {isTablet ? (
        <>
          <td>
            <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
              <SmallText className="black-transparent">
                <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
                  {date}
                </Moment>
              </SmallText>
              <SmallText className="bolder">
                <Mark colorStyle={status === 'late' ? 'ORANGE' : 'GREEN'}>
                  {status === 'sale' ? (
                    <FormattedMessage id="global_sold" defaultMessage={dlt['global_sold']} />
                  ) : status === 'late' ? (
                    <FormattedMessage id="global_late" defaultMessage={dlt['global_late']} />
                  ) : (
                    <FormattedMessage id="global_paid" defaultMessage={dlt['global_paid']} />
                  )}
                </Mark>
              </SmallText>
            </Link>
          </td>
          <td className="button-cell">
            <Button
              type="PRIMARY"
              className="cancel-button"
              size="MEDIUM"
              onClick={(event) => onCancelClick(event)}
            >
              <FormattedMessage
                id="global_cancel_sell"
                defaultMessage={dlt['global_cancel_sell']}
              />
            </Button>
          </td>
        </>
      ) : (
        <>
          <td>
            <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
              <BodyText>
                <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
                  {date}
                </Moment>
              </BodyText>
            </Link>
          </td>

          <td>
            <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
              <SmallText className="bolder">
                <Mark colorStyle={status === 'late' ? 'ORANGE' : 'GREEN'}>
                  {status === 'sale' ? (
                    <FormattedMessage id="global_sold" defaultMessage={dlt['global_sold']} />
                  ) : status === 'late' ? (
                    <>
                      <FormattedMessage id="global_late" defaultMessage={dlt['global_late']} />{' '}
                      {inArrear}{' '}
                      {inArrear === 1 ? (
                        <FormattedMessage id="global_day" defaultMessage={dlt['global_day']} />
                      ) : inArrear > 1 && inArrear <= 4 ? (
                        <FormattedMessage
                          id="global_more_days"
                          defaultMessage={dlt['global_more_days']}
                        />
                      ) : (
                        <FormattedMessage id="global_days" defaultMessage={dlt['global_days']} />
                      )}
                    </>
                  ) : (
                    <FormattedMessage id="global_paying" defaultMessage={dlt['global_paying']} />
                  )}
                </Mark>
              </SmallText>
            </Link>
          </td>
          {sellType === 'offered-manual' && (
            <>
              <td>
                <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
                  <span className={hasBiddings ? 'bid-counter' : 'bid-counter disabled'}>
                    {biddingsCount > 0 ? <small>{biddingsCount}</small> : null}

                    <AvatarIcon />
                  </span>
                </Link>
              </td>
              <td className="button-cell">
                <Button
                  type="PRIMARY"
                  className="cancel-button"
                  size="MEDIUM"
                  onClick={(event) => onCancelClick(event)}
                >
                  <FormattedMessage
                    id="global_cancel_sell"
                    defaultMessage={dlt['global_cancel_sell']}
                  />
                </Button>
              </td>
            </>
          )}
          <td>
            <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
              <RightArrowIcon />
            </Link>
          </td>
        </>
      )}
    </OffersItemSC>
  );
};

export default withRouter(OffersItem);
